var productWizardConstants = require('../Helpers/productWizardConstants');

module.exports = ['$scope', '$state', '$stateParams', '$location', '$anchorScroll', function ($scope, $state, $stateParams, $location, $anchorScroll) {
    var activeStyle = '';
    $location.hash('scrollto');
    if (typeof ($stateParams.style) === 'string') {
        activeStyle = $stateParams.style;
    }
    var activePrimaryColor = '';
    if (typeof ($stateParams.primaryColor) === 'string') {
        activePrimaryColor = $stateParams.primaryColor;
    }

    $scope.primaryColors = productWizardConstants.projectColors;

    $scope.selectedColor = function () {
        var iPrimaryColor = 0;
        var primaryColorText = '';

        for (iPrimaryColor = 0; iPrimaryColor < $scope.primaryColors.length; iPrimaryColor++) {
            if (activePrimaryColor == $scope.primaryColors[iPrimaryColor].id)
                primaryColorText = $scope.primaryColors[iPrimaryColor].name;
        }
        return primaryColorText
    };

    $scope.btnColorClass = function (option) {
        var classArray = [];

        if (option === 'white')
            classArray.push('white');
        if (activePrimaryColor === option)
            classArray.push('selected');

        return classArray.join(' ');
    };

    $scope.btnColorClick = function ($event, option) {
        $event.preventDefault();
        $state.go('primary-color', { style: activeStyle, primaryColor: option });
    };

    $scope.btnContinueClass = function () {
        if (activePrimaryColor === '')
            return 'disabled';
        return 'active';
    }

    $scope.btnBackClick = function ($event) {
        $event.preventDefault();
        $state.go('style', { style: activeStyle });
        $anchorScroll();
    };

    $scope.btnContinueClick = function ($event) {
        $event.preventDefault();
        $state.go('designer-color', { style: activeStyle, primaryColor: activePrimaryColor, mode: 'like' });
        $anchorScroll();
    };
}]